/**
 * 门店信息
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/store_info/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'province': '广东省',
    'province_code': '440000',
    'city': '深圳市',
    'city_code': '440300',
    'district': '南山区',
    'district_code': '440305'
  }
})
